<template>
  <div class="chart-block">
    <h3>   <a :href="url" target="_blank"> {{chartName}}</a> <span>{{updated}}</span></h3>
    <div class="sale-block" style="padding-top:15px">
      <div class="left" id="saleleft">
        <el-radio-group v-model="currentType">
                 <el-radio-button label="月销量"></el-radio-button>
          <el-radio-button label="年销量"></el-radio-button>
     
        </el-radio-group>

        <!-- <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
    <el-tab-pane label="年" name="first"> </el-tab-pane>
    <el-tab-pane label="月" name="second">  </el-tab-pane>
        </el-tabs>-->

        <div id="yearly" class="left-block" v-show="currentType=='年销量'">
          <div class="yearly-total">
               {{ thisYearSales |formatNumber}}
            <!-- <i class="el-icon-caret-top green" style="font-size:22px;"></i> -->
          </div>
          <div class="yearly-sale-m">
            <i class="el-icon-s-data green"></i> {{curYear}}度销量
          </div>
          <!-- <el-divider><i class="el-icon-s-data"></i></el-divider> -->
          <div style="height:1px; border-bottom:1px dashed #ccc;margin:10px;"></div>
          <div style="">
            <div class="last-year">{{lastYear}} 销量:  <span> {{ lastYearSales |formatNumber}}</span>   </div>
          </div>
        </div>

        <div id="monthly" class="left-block" v-show="currentType=='月销量'">
          <div class="yearly-total">
            {{lastMonth.sales | formatNumber}}
            <!-- <i class="el-icon-caret-top green" style="font-size:22px;"></i> -->
          </div>
          <div class="yearly-sale-m">
            <i class="el-icon-s-data green"></i> {{lastMonth.month}}
          </div>
          <!-- <el-divider><i class="el-icon-s-data"></i></el-divider> -->
          <div style="height:1px; border-bottom:1px dashed #ccc;margin:10px;"></div>
          <div style="display:flex">
            <div style="flex-grow:1;" v-html="month_comp(lastMonth,lylm,'同比')"> 
           
            </div>
            <div style="flex-grow:1;" v-html="month_comp(lastMonth,tmbl,'环比')">
            </div>
          </div>
        </div>
      </div>

      <div class="right" id="saleright">
        <div class="top">
          <el-select v-model="curYear" placeholder="请选择" size="small" style="display:none">
            <el-option v-for="item in years" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div id="chart_sale"></div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
import {
  formatDate,
  strToFormatDate,
  strToYeayAndMonth
} from "@/plugins/DateTimeFormater.js";
export default {
  props: {
    chartName: { type: String, default: "整体市场监控" }
  },
  data() {
    return {
      url:"#",
      chartOption: {},
      activeName: "yearly",
      years: ["2019年", "2020年"],
      curYear: "2020年",
      lastYear :'',
      thisYearSales:0,
      lastYearSales:0,
      currentType: "月销量",
      myChart: null,
      chartId: "market_monitor",
      updated: "",
      lastMonth:{},
      tmbl:{},//上上个月
      lylm:{},
      
    };
  },
  mounted() {
    this.chartOption = {
      color: ["#4ebdea", "#a7def3", "#327ed4"], //"#a7def3",
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      legend: {
        data: ["最近12个月", "去年同期"]
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
        borderWidth: 0
      },
      xAxis: [
        {
          type: "category",
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { color: "#47bae7" },
          data: []
        }
      ],
      yAxis: [
        {
          type: "value",
          axisLabel: { color: "#47bae7" },
          axisLine: { show: false },
          splitLine: { show: true, lineStyle: { type: "dashed" } },
          axisTick: { show: false },
          splitArea: { show: false },
          splitNumber: 4
        }
      ],
      series: [
        {
          name: "最近12个月",
          type: "bar",
          //stack: "销量",
        //  barGap: "-100%",
          barMaxWidth: 20,
          data: []
        },
        {
          name: "去年同期",
          type: "bar",
          //stack: "销量",
          barMaxWidth: 20,
          data: []
        }
      ]
    };
    this.getChartList({ handle: this.updateChart });
  },
  methods: {
    ...mapActions("home", [
      "queryChartConfigs",
      "queryChartUpdate",
      "getChartList"
    ]),
    handleClick() {},
    switchTab() {
     // alert(this.currentType);
    },
    updateChart() {
      var dict = this.zhm;

      this.myChart = echarts.init(document.getElementById("chart_sale"));
      var info = this.getChartByName(this.chartId);
 this.url = info.url;
      var jsArr = eval(info.jsonData);
      var gp = this.group(jsArr, 12);
      
      //  var thisYears = jsArr.filter(x=>x.month.substr(0, 4)==ty );
      //  alert(JSON.stringify(thisYears));
      // var ly = ty-1;
      //   var lastYears = jsArr.filter(x=>x.month.substr(0, 4)==ly );
      //  alert(JSON.stringify(lastYears));
      //alert(JSON.stringify(gp[0].map(x=>x.sales)));

 
      var thisyear = (new Date()).getFullYear() ;
      this. curYear =thisyear +'年';
      this.lastYear = (thisyear -1)+'年';

        var thisYears = jsArr.filter(x=>x.month.substr(0, 4)==thisyear ) ;
     
        var ty_sales = 0;
        for(let item of thisYears)
        {
             ty_sales += item.sales;
        }
       this.thisYearSales = ty_sales;
      var lastYears = jsArr.filter(x=>x.month.substr(0, 4)==(thisyear -1) ) ;

      var ly_sales = 0;
        for(let item of lastYears)
        {
             ly_sales += item.sales;
        }
       this.lastYearSales = ly_sales;
      this.chartOption.series[1].data = gp[0].map(x => x.sales);
      this.chartOption.series[0].data = gp[1].map(x => x.sales);

      this.chartOption.xAxis[0].data = gp[0]
        .map(x => x.month)
        .map(x => dict[x.substr(5, 2)]);

      this.myChart.setOption(this.chartOption);
      window.addEventListener("resize", function() {
        this.myChart && this.myChart.resize();
      });
      this.lastMonth = jsArr[jsArr.length-1];
      this.tmbl =jsArr[jsArr.length-2];
      this.lylm = gp[0][gp[0].length -1 ];
      //alert(JSON.stringify(this.lastMonth));
      this.updated = `${strToYeayAndMonth(info.lastUpdated)}更新`;
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },
    percentage(num, total) { 
    if (num == 0 || total == 0){
        return 0;
    }
    return (Math.round(num / total * 10000) / 100.00);// 小数点后两位百分比
},
     month_comp(cur,last,label){
        var color = 'red';
        var fix = '';
        if(cur.sales < last.sales)
        {
            color ='green';
            fix ='-';
        }
        return ' <div class="sale-pre '+color+'"> '+fix +this.percentage(cur.sales,last.sales)+'% </div>'+label;
      }
  },

  computed: {
    ...mapGetters("home", {
      chartList: "chartList",
      getChartByName: "getChartByName"
    }),
    zhm(){
        return {
        "01": "一月",
        "02": "二月",
        "03": "三月",
        "04": "四月",
        "05": "五月",
        "06": "六月",
        "07": "七月",
        "08": "八月",
        "09": "九月",
        "10": "十月",
        "11": "十一月",
        "12": "十二月"
      };
    }
  },
  filters:{
      formatNumber(num){ 
         return (num/10000.00).toFixed(2) +'万辆';
      }
  }
};
</script>
<style scored>
.chart-block h4.ss {
  position: absolute;
  left: 30%;
}
.sale-block {
  display: flex;
  flex-wrap: nowrap;
}
.sale-block .left {
  width: 450px;
  padding: 0 0 20px 30px;
}
.sale-block .right {
  flex-grow: 1;
}
.el-tabs__nav-wrap::after {
  background-color: #fff !important;
}
.sale-pre {
  font-size: 38px;
  font-weight: bolder;
}

.yearly-total {
  font-size: 38px;
  font-weight: bolder;
}
.yearly-sale-m {
  padding: 10px 5px;
}
#chart_sale {
  min-height: 250px;
  width: 100%;
}
#saleright .el-input__inner {
  border-radius: 12px !important;
}
#saleright .top {
  text-align: right;
  padding: 15px 30px 0 0;
}
.left-block {
  margin-top: 20px;
}
.last-year{
    text-align: center;
    line-height: 3em;
    font-size: 1.3em;
    color:#3ec396;
}
</style>
 